module.exports = __webpack_public_path__ + "img/11825394_L.c6ab4fee.png";